import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { showTemuConfirm } from '@/temu-platform/components/TemuConfirmDialog';
import TemplateChangeDiffList from '@/temu-platform/modules/products/components/TemplateChangeDiffList';

/**
 * 字段旁版本冲突标记（对齐草图：控件左侧指示，非整块色条）。
 * resolveChangePreview: 可选，返回 { changes, title?, intro? } 用于确认弹窗展示变更明细。
 */
export default function TemplateVersionConflictMark({
  active = false,
  label = fixedUi("已更新"),
  onReload,
  resolveChangePreview,
  reloading = false,
  className = '',
}) {
  if (!active) return null;

  const handleReload = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (reloading || typeof onReload !== 'function') return;

    let preview = null;
    if (typeof resolveChangePreview === 'function') {
      try {
        preview = await resolveChangePreview();
      } catch {
        preview = null;
      }
    }

    const changes = Array.isArray(preview?.changes) ? preview.changes : [];
    const ok = await showTemuConfirm({
      title: preview?.title || '重新加载模板区域',
      message: (
        <TemplateChangeDiffList
          intro={preview?.intro || '以下字段与模板库最新版本不一致，重新加载将覆盖对应区域（其它区域保留）：'}
          changes={changes}
          emptyText={preview?.emptyText}
        />
      ),
      tone: 'warning',
      confirmText: '重新加载',
      cancelText: '取消',
      wide: true,
    });
    if (!ok) return;
    onReload();
  };

  return (
    <span
      className={`tpo-version-conflict-mark${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
      title={label}
    >
      <span className="tpo-version-conflict-mark__badge" aria-hidden="true">
        <svg viewBox="0 0 16 16" width="12" height="12" focusable="false">
          <path
            d="M4.2 4.2l7.6 7.6M11.8 4.2l-7.6 7.6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span className="tpo-version-conflict-mark__meta">
        <span className="tpo-version-conflict-mark__text">{label}</span>
        {typeof onReload === 'function' ? (
          <button
            type="button"
            className="tpo-version-conflict-mark__reload"
            disabled={reloading}
            onClick={handleReload}
          >
            {reloading ? fixedUi("加载中…") : fixedUi("重新加载")}
          </button>
        ) : null}
      </span>
    </span>
  );
}
